/**
 * Portfolio Page Component
 * 
 * Main component that orchestrates the entire portfolio page layout.
 * This component brings together all portfolio-related sections including:
 * - Portfolio header with title and description
 * - Portfolio gallery displaying work samples (religious vestments, personalized items)
 * 
 * The portfolio showcases products including:
 * - Casullas (chasubles) and religious vestments
 * - Personalized towels and linens
 * - Embroidered items with names and designs
 * - Altar cloths and religious accessories
 * 
 * @component
 * @returns {JSX.Element} The complete portfolio page layout
 */

import React from 'react';
import PortfolioHeader from '../../components/portfolio/portfolio-header/portfolio-header';
import PortfolioGallery from '../../components/portfolio/portfolio-gallery/portfolio-gallery';
import './portfolio-style.css';

const Portfolio = () => {
  return (
    <div className="portfolio">
      {/* Main container for all portfolio page content */}
      <div className="portfolio__container">
        {/* Portfolio header with title and description */}
        <PortfolioHeader />
        
        {/* Gallery section displaying all portfolio items */}
        <PortfolioGallery />
      </div>
    </div>
  );
};

export default Portfolio;
